import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import { getCategory2productInfoByCategoryIdAPI } from '../Category2productAPI';

export default function MfproductListByCategory({ categoryId }) {
    const [mappingList, setMappingList] = useState([]);
    const [filteredProductList, setFilteredProductList] = useState([]); // State for filtered and sorted product list
    const [searchTitle, setSearchTitle] = useState(''); // State for user input to filter products
    const { mfproductList } = useSelector((state) => state.manufslice);
    const { category2productList } = useSelector((state) => state.manufslice);

    useEffect(() => {
        // Fetch and sort the mapping list by id
        getCategory2productInfoByCategoryIdAPI(categoryId, () => { }, (data) => {
            const sortedList = data.sort((a, b) => a.id - b.id);
            setMappingList(sortedList);
        });
    }, [category2productList]);

    useEffect(() => {
        // Filter and sort the product list based on mappingList and searchTitle
        if (mfproductList && mappingList.length > 0) {
            const filteredList = mfproductList
                .filter((product) => 
                    mappingList.some((mapping) => mapping.productid === product.id) && 
                    product.title.toLowerCase().includes(searchTitle.toLowerCase()) // Filter by title
                )
                .sort((a, b) => a.title.localeCompare(b.title)); // Sort by title
            setFilteredProductList(filteredList);
        }
    }, [mfproductList, mappingList, searchTitle]);

    return (
        <>
            {/* TextField for filtering products */}
            {/* <Box sx={{ marginBottom: 2, padding:.5 }}>
                <TextField
                    label="Search Product Title"
                    variant="outlined"
                    fullWidth
                    value={searchTitle}
                    onChange={(e) => setSearchTitle(e.target.value)} // Update searchTitle state
                />
            </Box> */}

            <Grid container direction="row" sx={{ width: '100%' }}>
                <Box lg={12} sx={{ flexGrow: 1 }}>
                    <Grid
                        container
                        direction="row"
                        sx={{
                            overflowY: 'scroll',
                            backgroundColor: 'secondary.100',
                            maxHeight: { lg: '67vh', xs: '78vh' },
                        }}
                    >
                        {filteredProductList.map((productObj) => (
                            <Grid
                                item
                                key={productObj.id}
                                xs={6}
                                sm={3}
                                md={3}
                                lg={2}
                                sx={{ padding: 1 }}
                            >
                                <Grid
                                    container
                                    direction="column"
                                    sx={{
                                        backgroundColor: 'white',
                                        cursor: 'pointer',
                                        padding: 1,
                                        borderRadius: 2,
                                        width: '100%',
                                    }}
                                >
                                    <Grid item>
                                        <Typography variant="h6" color="primary.dark">
                                            {productObj.code}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="h6" color="primary.darker">
                                            {productObj.title}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Grid>
        </>
    );
}